import S from 's-js';

export function memoize<T, U>(fn : (v : T) => U) : (v : T) => U {
    const map = new Map<T, () => U>(),
        disposers = [] as (() => void)[];

    S.cleanup(() => disposers.forEach(disposer => disposer()));

    return (v : T) : U => {
        if (map.has(v)) return map.get(v)!();
        const sub = S.root(dispose => {
            disposers.push(dispose);
            return S(() => fn(v));
        });
        map.set(v, sub);
        return sub();
    }
}


// WEBPACK FOOTER //
// ./lib/memoize.ts